import { useContext } from 'react'

import { selectAgentV2ConversationFromId } from '@/agent-v2/conversations/store/selectors'
import { AuthContext } from '@/context/auth-context'
import type { RootState } from '@/store/store'
import { useAppSelector } from '@/store/store-hooks'

/** Whether the authenticated Firebase user created this conversation. */
export function useIsAgentV2ConversationCreator(conversationId: string | undefined): boolean {
  const { user } = useContext(AuthContext)
  const conversation = useAppSelector((state: RootState) => selectAgentV2ConversationFromId(state, { conversationId }))

  return Boolean(user?.uid && conversation?.created_by_user_id === user.uid)
}
